// Presentation only: use persisted, entry-scoped picks and their exact fixtures.
import {buildTeamCrestMap} from './teamAssets.js';
const key = value => String(value || '').trim().toLowerCase();
const confirmed = name => !!key(name) && !/^(tbc|to be confirmed|winner |runner-up |runner up )/.test(key(name));

export function dashboardCurrentPicks(row, data) {
  if (!['knockout', 'season'].includes(row.competition_type) || !data?.competition || !data.picks) return [];
  if (data.entry?.id !== row.entry_id || data.competition.current_match_day == null) return [];
  return data.picks.filter(pick => pick.entry_id === row.entry_id
    && Number(pick.match_day) === Number(data.competition.current_match_day) && key(pick.selected_team));
}

export function dashboardSelectedTeams(row, data) {
  return dashboardCurrentPicks(row, data).map(pick => {
      const fixture = data.fixtures?.find(item => item.id === pick.fixture_id
        && [key(item.home_team), key(item.away_team)].includes(key(pick.selected_team)));
      const opponent = fixture && (key(pick.selected_team) === key(fixture.home_team) ? fixture.away_team : fixture.home_team);
      return {
        name: pick.selected_team,
        crest: data.teamCrests?.[key(pick.selected_team)] || null,
        opponent: confirmed(opponent) ? opponent : null,
        kickoff: fixture?.kickoff_time || null,
        fixtureStatus: fixture?.status || null,
        fixtureId: fixture?.id || null,
      };
    });
}

export const dashboardTeamCrests = buildTeamCrestMap;

// Outstanding obligations and exceptions are separate from proof of a saved team.
// These messages explain existing flags; the selection page still checks eligibility.
export function dashboardSelectionGuidance(row, data, play) {
  if (!data?.entry || data.entry.id !== row.entry_id || data.entry.status !== 'active'
    || data.competition?.status !== 'active' || data.competition.current_match_day == null
    || !['knockout', 'season'].includes(row.competition_type)) return [];
  const {entry, competition} = data;
  const count = dashboardSelectedTeams(row, data).length;
  const messages = [];
  const replacement = row.competition_type === 'knockout' && entry.must_pick_double
    && (entry.abandoned_on_matchdays || []).includes(competition.current_match_day);
  const incompleteDouble = row.competition_type === 'knockout' && entry.must_pick_double
    && !replacement && Array.isArray(data.picks) && count < 2;
  if (replacement) {
    messages.push({kind:'exception', title:'Check your replacement selection', detail:'An abandonment affects this matchday. Check your permitted alternative pick in your game; this replacement does not require two teams.'});
  } else if (incompleteDouble) {
    messages.push({kind:'required', title:play.state === 'missing' ? count === 1 ? 'Choose your second team' : 'Choose two teams' : 'Double pick incomplete',
      detail:`${count} of 2 required picks saved. ${play.state === 'missing' ? 'Choose and confirm '+(count === 1 ? 'another team' : 'both teams')+' to complete your double pick.' : play.exception ? 'The normal deadline has passed. Check the double-pick exception and qualifying future fixtures in your game.' : 'Check your game for the selection window and permitted options to complete your double pick.'}`});
  }
  if (play.exception && count === 0 && !replacement && !incompleteDouble) {
    messages.push({kind:'exception', title:'Check selection options', detail:entry.must_pick_double
      ? 'The normal deadline has passed. Check the double-pick exception and qualifying future fixtures in your game.'
      : 'The normal deadline has passed. Check qualifying future fixtures and any available Last Chance Chip option in your game.'});
  }
  if (row.competition_type === 'season' && entry.postponement_credits > 0 && count === 1 && play.state !== 'settled') {
    messages.push({kind:'exception', title:'Postponement credit available', detail:'Check your game for adding a second selection with your postponement credit, or replacing your existing pick. Selection windows still apply.'});
  }
  return messages;
}
